import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import "./style.css";

interface MenuItem {
  id: number;
  title: string;
  link: string;
  submenu?: MenuItem[];
  isHeader?: boolean;
  isExternal?: boolean;
}



const MobileMenu: React.FC = () => {
  const [openId, setOpenId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <ul className="responsivemenu">
      {menus.map((menu) => (
        <li key={menu.id} className={openId === menu.id ? "active" : ""}>
          {menu.submenu ? (
            <Fragment>
              <p onClick={() => handleToggle(menu.id)}>
                {menu.title}
                <i
                  className={
                    openId === menu.id ? "fa fa-angle-up" : "fa fa-angle-down"
                  }
                ></i>
              </p>

              {/* MUI Collapse for smooth animation */}
              <Collapse in={openId === menu.id} timeout="auto" unmountOnExit>
                <ul className="subMenu">
                  {menu.submenu.map((sub) => (
                    <li key={sub.id}>
                      {sub.isHeader ? (
                        <span
                          style={{
                            display: "block",
                            padding: "10px 20px 5px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#fc9038", // Main orange color
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                            pointerEvents: "none"
                          }}
                        >
                          {sub.title}
                        </span>
                      ) : (
                        <Link to={sub.link} onClick={handleClick}>
                          {sub.title}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </Collapse>
            </Fragment>
          ) : menu.isExternal ? (
            <a
              href={menu.link}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClick}
            >
              {menu.title}
            </a>
          ) : (
            <Link to={menu.link} onClick={handleClick}>
              {menu.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MobileMenu;
const menus: MenuItem[] = [
  {
    id: 1,
    title: "About Us",
    link: "/about-us",
  },
  {
    id: 2,
    title: "Corporate Social Responsibility",
    link: "/corporate-social-responsibility",
  },
  {
    id: 3,
    title: "Services",
    link: "#",
    submenu: [
      // AI
      { id: 2001, title: "AI", link: "#", isHeader: true },
      { id: 201, title: "AI Agents", link: "/services/ai-agents" },
      { id: 202, title: "Generative AI", link: "/services/generative-ai" },
      { id: 203, title: "AI Driven Web Scraping", link: "/services/ai-web-scraping" },
      { id: 204, title: "Machine Learning", link: "/services/machine-learning" },

      // Digital Transformation
      { id: 2002, title: "Digital Transformation", link: "#", isHeader: true },
      { id: 205, title: "Legacy Modernization", link: "/services/legacy-modernization" },

      // Professional Staffing
      { id: 2003, title: "Professional Staffing", link: "#", isHeader: true },
      { id: 206, title: "Contract Hiring", link: "/services/contract-hiring" },

      // Web Development
      { id: 2004, title: "Web Development", link: "#", isHeader: true },
      { id: 207, title: "Web Portal Design & Development", link: "/services/web-portal-development" },
      { id: 208, title: "System Integration", link: "/services/system-integration" },
      { id: 209, title: "Ecommerce website", link: "/services/ecommerce-website" },
      { id: 210, title: "Business Websites", link: "/services/business-websites" },

      // Branding & Identity
      { id: 2005, title: "Branding & Identity", link: "#", isHeader: true },
      { id: 211, title: "Branding", link: "/services/branding" },

      // Data Migration
      { id: 2006, title: "Data Migration", link: "#", isHeader: true },
      { id: 212, title: "Cloud Migration", link: "/services/cloud-migration" },
      { id: 213, title: "Email Migration", link: "/services/email-migration" },

      // Others
      { id: 2007, title: "Other Services", link: "#", isHeader: true },
      { id: 214, title: "Website/Software Maintenance", link: "/services/software-maintenance" },
      { id: 215, title: "Mobile App Development", link: "/services/mobile-app-development" },
      { id: 216, title: "AR/VR Development", link: "/services/ar-vr-development" },
      { id: 217, title: "Graphic Designing", link: "/services/graphic-designing" },
    ],
  },
  {
    id: 4,
    title: "Solutions",
    link: "#",
    submenu: [
      // Cloud Solutions
      { id: 3001, title: "Cloud Solutions", link: "#", isHeader: true },
      { id: 301, title: "Hybrid Cloud", link: "/solutions/hybrid-cloud" },
      { id: 302, title: "Private Cloud", link: "/solutions/private-cloud" },
      { id: 303, title: "Managed Cloud Solutions", link: "/solutions/managed-cloud" },
      { id: 304, title: "Cloud Consulting", link: "/solutions/cloud-consulting" },
      { id: 305, title: "AWS Services", link: "/solutions/aws-services" },

      // ERP Solutions
      { id: 3002, title: "ERP Solutions", link: "#", isHeader: true },
      { id: 306, title: "HR & Payroll", link: "/solutions/hr-payroll" },
      { id: 307, title: "Manufacturing", link: "/solutions/manufacturing-erp" },
      { id: 308, title: "CRM", link: "/solutions/crm" },
      { id: 309, title: "Supply Chain", link: "/solutions/supply-chain" },

      // Business Enablement Solutions
      { id: 3003, title: "Business Enablement", link: "#", isHeader: true },
      { id: 310, title: "WhatsApp AI Bots", link: "/solutions/whatsapp-ai-bots" },
      // { id: 311, title: "SMS", link: "/solutions/sms" },
      // { id: 312, title: "Email", link: "/solutions/email" },
      // { id: 313, title: "Voice", link: "/solutions/voice" },
      { id: 314, title: "Domain Management", link: "/solutions/domain-management" },
      { id: 315, title: "DNS", link: "/solutions/dns" },
      // { id: 316, title: "Digital Signing", link: "/solutions/digital-signing" },
    ],
  },
  {
    id: 5,
    title: "Products",
    link: "#",
    submenu: [
      { id: 401, title: "Safal School AI ERP", link: "https://safalschool.com", isExternal: true },
      { id: 402, title: "Revyv Church", link: "https://revyv.church", isExternal: true },
      { id: 403, title: "Suveeksha (VR Learning)", link: "/contact-us" },
    ],
  },
  {
    id: 6,
    title: "Careers",
    link: "/careers",
  },
  {
    id: 7,
    title: "Blog",
    link: "https://blog.aquarlabs.com",
    isExternal: true,
  },
  {
    id: 8,
    title: "Contact Us",
    link: "/contact-us",
  },
];